import { PricesResendManager } from "..";
import { YieldType } from "../../../service/globalTypes";
import { MAX_NUMBER_OF_RETRIES } from "../constants";
import { StatusCodes } from "../types";
import { getYieldsToResend } from "./getYieldsToResend";
import { handleErrorResending } from "./handleErrorResending";
import { handlePartialSuccessfulResend } from "./handlePartialSuccessfulResend";
import { handleSuccessfulResend } from "./handleSuccessfulResend";
import { resendPricesStatusList } from "./resendPricesStatusList";
import { HandleResendValuesArgs } from "./types";

export const handleResendValues = async ({
  bid,
  ask,
  currentErrorSentYields,
  row,
  tryNumber,
  errorData,
  ...restOfProps
}: HandleResendValuesArgs) => {
  const yieldsToResend = getYieldsToResend({
    ...restOfProps,
    bid,
    ask,
    currentErrorSentYields,
  });
  const resendTryResults = await resendPricesStatusList({
    yields: yieldsToResend,
  });

  if (resendTryResults.every((result) => result.sentSuccessfully)) {
    handleSuccessfulResend({ row, resendTryResults, bid, ask });
    return { successfullySent: true };
  }

  handlePartialSuccessfulResend({ resendTryResults, row, bid, ask, currentErrorSentYields });

  if (tryNumber === MAX_NUMBER_OF_RETRIES) {
    const statusCodes: StatusCodes = {};

    const bidStatusCode = resendTryResults.find((result) => result.yieldType === YieldType.BID)?.statusCode;
    const askStatusCode = resendTryResults.find((result) => result.yieldType === YieldType.ASK)?.statusCode;

    if (bidStatusCode) statusCodes.bid = bidStatusCode;
    if (askStatusCode) statusCodes.ask = askStatusCode;

    handleErrorResending({
      errorData,
      row,
      currentErrorSentYields,
      statusCodes,
      errorsThatCantBeSent: PricesResendManager.getInstance().getErrorsThatCantBeSent(),
    });
  }

  return { successfullySent: false };
};
